import { ChildStep, ParentStep } from '@/types/steps';

export const computeNextStepPath = (
  steps: readonly ParentStep<unknown>[],
  parentId: string | undefined,
  childId: string | undefined,
): string | null => {
  const parentIndex = steps.findIndex(
    (step: ParentStep<unknown>): boolean => step.path === parentId,
  );
  if (parentIndex === -1) {
    // TODO: do we throw here?
    return null;
  }

  const currentParent = steps[parentIndex];
  const nextParent = steps[parentIndex + 1];

  const { children: siblings } = currentParent;

  const childIndex = siblings.findIndex(
    (step: ChildStep<unknown>): boolean => step.path === childId,
  );
  if (childIndex === -1) {
    // TODO: do we throw here?
    return null;
  }

  const nextChild = siblings[childIndex + 1];
  if (nextChild) {
    return [currentParent.path, nextChild.path].join('/');
  } else if (nextParent) {
    const { children } = nextParent;
    if (children.length === 0) {
      return nextParent.path;
    }
    return [nextParent.path, children[0].path].join('/');
  } else {
    return null;
  }
};
